export default "__VITE_ASSET__rto8Kt4K__"